import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onBlur", "onChange", "onSearch", "onSelect", "regions", "value"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { StatelessSearchInput } from '@beef/ui-kit';
import { filterRegions } from "../../filterRegions";
export var NAutoSearchInput = function NAutoSearchInput(_ref) {
  var onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onSearch = _ref.onSearch,
    onSelect = _ref.onSelect,
    regions = _ref.regions,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(regions),
    _useState2 = _slicedToArray(_useState, 2),
    currentOptions = _useState2[0],
    setCurrentOptions = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    activeOption = _useState4[0],
    setActiveOption = _useState4[1];
  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", filterRegions(regions, query));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSearch(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleChangeOptions = function handleChangeOptions(query) {
    if (activeOption) setActiveOption(undefined);
    var resultRegions = query !== null && query !== void 0 && query.length ? query : [];
    setCurrentOptions(resultRegions);
  };
  var options = value ? currentOptions : regions;
  var handleSelectOption = function handleSelectOption(query) {
    setActiveOption(query);
    setCurrentOptions(options);
    onSelect === null || onSelect === void 0 || onSelect(query);
  };
  return /*#__PURE__*/React.createElement(StatelessSearchInput, _extends({
    activeOption: activeOption,
    onBlur: onBlur,
    onChange: onChange,
    onChangeOptions: handleChangeOptions,
    onSearch: handleSearch,
    onSelect: handleSelectOption,
    options: options,
    value: value
  }, props, {
    "data-t-id": "components-NAutoSearchInput"
  }));
};